import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Create the context
const ResultsContext = createContext();

// Custom hook to use the context
export const useResults = () => {
  const context = useContext(ResultsContext);
  if (!context) {
    throw new Error('useResults must be used within a ResultsProvider');
  }
  return context;
};

// Provider component
export const ResultsProvider = ({ children }) => {
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const runModel = async () => {
    try {
      setIsLoading(true);
      setError(null);
      // console.log('Starting long-term model execution...');
      
      const response = await axios.post('http://localhost:8000/api/run/long-term-model');
      
      // console.log('Long-term model results:', response.data);
      
      // Extract the results from the response
      const modelResults = response.data.data.results || [];
      setResults(modelResults);
      
      // Navigate to results page
      navigate('/results');
      
    } catch (error) {
      console.error('Error running long-term model:', error);
      setError(error.message);
      
      if (axios.isAxiosError(error)) {
        console.error('API Error:', error.response?.data);
        setError(error.response?.data?.detail || 'API request failed');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const clearResults = () => {
    setResults([]);
    setError(null);
  };

  const value = {
    results,
    isLoading,
    error,
    runModel,
    clearResults
  };

  return (
    <ResultsContext.Provider value={value}>
      {children}
    </ResultsContext.Provider>
  );
};
